<template>
  <v-card>
    <v-toolbar color="primary" class="white--text">
      Δημιουργία παρουσίας
      <v-btn
        depressed
        icon
        color="white"
        class="ml-auto"
        @click="$emit('close')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-4">
      <v-form @submit.prevent="onSubmit" class="pa-4">
        <v-select
          v-model="tpy"
          class="mb-4"
          :error-messages="tpyErrors"
          :items="getDataStaticList(140)"
          item-text="description"
          item-value="cd"
          dense
          @change="onChangeTpy"
          outlined
          no-data-text="Δεδομένα μη διαθέσιμα"
        >
          <template v-slot:label>
            <span class="error--text">*</span>
            Τύπος πραγματοποιηθείσας ώρας εκπαιδευτικού
          </template>
        </v-select>

        <v-select
          dense
          outlined
          clearable
          v-if="tpy == 'Π'"
          :label="'Θέματα πτυχιακής'"
          v-model="thesisId"
          :items="listThesis"
          item-text="description"
          item-value="cd"
          @change="setTeacherList"
          :error-messages="thesisIdErrors"
          no-data-text="Δεδομένα μη διαθέσιμα"
        >
          <template v-slot:label>
            <span class="error--text">*</span>Θέματα πτυχιακής
          </template>
        </v-select>
        <v-select
          dense
          outlined
          clearable
          v-if="tpy == 'Δ'"
          :label="appId == 1 ? 'Εξάμηνο σπουδών' : 'Κύκλο σπουδών'"
          v-model="semesterId"
          :items="listSemester"
          item-text="description"
          item-value="cd"
          @change="onSetSemester"
          :error-messages="semesterIdErrors"
          no-data-text="Δεδομένα μη διαθέσιμα"
        >
          <template v-slot:label>
            <span class="error--text">*</span
            >{{ appId == 1 ? "Εξάμηνο σπουδών" : "Κύκλο σπουδών" }}
          </template>
        </v-select>
        <v-select
          dense
          outlined
          clearable
          v-if="tpy == 'Ε'"
          :label="'Εξεταστική περίοδος'"
          v-model="examId"
          :items="listExam"
          item-text="description"
          item-value="cd"
          @change="onSetExam"
          :error-messages="examIdErrors"
          no-data-text="Δεδομένα μη διαθέσιμα"
        >
          <template v-slot:label>
            <span class="error--text">*</span>Εξεταστική περίοδος
          </template>
        </v-select>

        <v-select
          dense
          outlined
          clearable
          v-if="tpy == 'Ε'"
          :label="'Τμήμα/Μάθημα'"
          v-model="classCourseId"
          :items="listClassCourse"
          item-text="description"
          item-value="cd"
          @change="setTeacherList"
          :error-messages="classCourseIdErrors"
          no-data-text="Δεδομένα μη διαθέσιμα"
        >
          <template v-slot:label>
            <span class="error--text">*</span>Τμήμα/Μαθήμα
          </template>
        </v-select>

        <v-select
          dense
          outlined
          clearable
          v-if="tpy == 'Δ'"
          :label="'Τμήμα'"
          v-model="classId"
          :items="listClass"
          item-text="description"
          item-value="cd"
          @change="setTeacherList"
          :error-messages="classIdErrors"
          no-data-text="Δεδομένα μη διαθέσιμα"
        >
          <template v-slot:label>
            <span class="error--text">*</span>Τμήμα
          </template>
        </v-select>

        <v-select
          dense
          outlined
          clearable
          v-if="tpy == 'Δ'"
          :label="'Μαθήματα'"
          v-model="courseId"
          :items="listCourse"
          item-text="description"
          item-value="cd"
          @change="setTeacherList"
          :error-messages="courseIdErrors"
          no-data-text="Δεδομένα μη διαθέσιμα"
        >
          <template v-slot:label>
            <span class="error--text">*</span>Μαθήματα
          </template>
        </v-select>
        <v-autocomplete
          v-model="trainnerId"
          class="mb-4"
          :error-messages="trainnerIdErrors"
          :items="teacherList"
          item-text="description"
          item-value="cd"
          dense
          outlined
        >
          <template v-slot:label>
            <span class="error--text">*</span>
            Εκπαιδευτικός
          </template>
        </v-autocomplete>

        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              outlined
              v-model="entryDateFormatted"
              v-bind="attrs"
              v-on="on"
              class="mb-4"
              @blur="entryDate = parseDate(entryDateFormatted, 'entryDate')"
              :error-messages="entryDateErrors"
              :disabled="trainnerId == null || lessonLoader"
            >
              <template v-slot:prepend-inner>
                <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
              </template>
              <template v-slot:label>
                <span class="error--text">*</span>
                Ημερομηνία παρουσίας
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            locale="el"
            v-model="entryDate"
            scrollable
            @input="menu = false"
          >
          </v-date-picker>
        </v-menu>

        <v-text-field
          v-model="numOfHours"
          class="mb-4"
          :error-messages="numOfHoursErrors"
          dense
          outlined
          :disabled="trainnerId == null || lessonLoader"
        >
          <template v-slot:label>
            <span class="error--text">*</span>
            Πλήθος ωρών την ημέρα
          </template>
        </v-text-field>

        <div class="d-flex justify-center">
          <v-btn depressed color="error" @click="$emit('close')">Ακύρωση</v-btn>
          <v-btn
            depressed
            color="success"
            class="ml-4"
            type="submit"
            :loading="loader"
            >Δημιουργία</v-btn
          >
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { required, numeric, requiredIf } from "vuelidate/lib/validators";
import axios from "axios";

const isFormattedDate = (dateString) => {
  if (dateString == null) return false;
  let regEx =
    /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/g;
  return dateString.match(regEx) != null;
};

export default {
  props: ["from"],

  async created() {
    try {
      // await this.getTeacherList({
      //   type: 1,
      //   roleId: this.selectedRole,
      //   parentCd: this.classId + this.courseId,
      // });
      this.entryDate = this.dates;
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      loader: false,
      lessonLoader: false,

      entryDate: null,
      entryDateFormatted: null,
      numOfHours: null,
      tpy: null,
      trainnerId: null,
      lessonId: null,
      listSemester: [],
      semesterId: null,
      classId: null,
      listClass: [],
      courseId: null,
      listCourse: [],
      teacherList: [],
      listThesis: [],
      thesisId: null,
      examId: null,
      listExam: [],
      classCourseId: null,
      listClassCourse: [],
      menu: false,
    };
  },

  validations() {
    const self = this;
    return {
      entryDate: {
        required,
      },
      semesterId: {
        required: requiredIf((e) => {
          return self.tpy == "Δ";
        }),
      },
      classId: {
        required: requiredIf((e) => {
          return self.tpy == "Δ";
        }),
      },
      courseId: {
        required: requiredIf((e) => {
          return self.tpy == "Δ";
        }),
      },
      thesisId: {
        required: requiredIf((e) => {
          return self.tpy == "Π";
        }),
      },
      examId: {
        required: requiredIf((e) => {
          return self.tpy == "Ε";
        }),
      },
      classCourseId: {
        required: requiredIf((e) => {
          return self.tpy == "Ε";
        }),
      },
      tpy: {
        required,
      },

      trainnerId: {
        required,
      },

      numOfHours: {
        required,
        numeric,
      },
    };
  },

  watch: {
    entryDate(val) {
      this.entryDateFormatted = this.formatDate(this.entryDate);
    },
  },

  computed: {
    ...mapState({
      attendLessons: (state) => state.attend_lessons.attendLessons,
      appId: (state) => state.auth.appId,
      staticList: (state) => state.auth.userInfo.staticView,
      facultyId: (state) => state.generic_filter.facultyId,
      schoolId: (state) => state.generic_filter.schoolId,
      academicYearId: (state) => state.generic_filter.academicYearId,
      progTrainPeriodId: (state) => state.generic_filter.semesterId,
      dates: (state) => state.generic_filter.dates,
      selectedRole: (state) => state.auth.selectedRole,
    }),

    entryDateErrors() {
      const errors = [];
      if (!this.$v.entryDate.$dirty) return errors;
      if (!this.$v.entryDate.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    tpyErrors() {
      const errors = [];
      if (!this.$v.tpy.$dirty) return errors;
      if (!this.$v.tpy.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    thesisIdErrors() {
      const errors = [];
      if (!this.$v.thesisId.$dirty) return errors;
      if (!this.$v.thesisId.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    semesterIdErrors() {
      const errors = [];
      if (!this.$v.semesterId.$dirty) return errors;
      if (!this.$v.semesterId.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    examIdErrors() {
      const errors = [];
      if (!this.$v.examId.$dirty) return errors;
      if (!this.$v.examId.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    classCourseIdErrors() {
      const errors = [];
      if (!this.$v.classCourseId.$dirty) return errors;
      if (!this.$v.classCourseId.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    classIdErrors() {
      const errors = [];
      if (!this.$v.classId.$dirty) return errors;
      if (!this.$v.classId.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    courseIdErrors() {
      const errors = [];
      if (!this.$v.courseId.$dirty) return errors;
      if (!this.$v.courseId.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    trainnerIdErrors() {
      const errors = [];
      if (!this.$v.trainnerId.$dirty) return errors;
      if (!this.$v.trainnerId.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    numOfHoursErrors() {
      const errors = [];
      if (!this.$v.numOfHours.$dirty) return errors;
      if (!this.$v.numOfHours.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.numOfHours.numeric) errors.push("Επιτρέπονται μόνο ψηφία");
      return errors;
    },
  },

  methods: {
    ...mapActions(["addTeacherHour", "getTeacherList", "getAttendLessons"]),
    async onChangeTpy(value) {
      if (value == "Δ") {
        this.thesisId = null;
        this.listThesis = [];
        this.examId = null;
        this.listExam = [];
        let result = await this.fetchDataDynamic(2003, this.academicYearId);
        this.listSemester = result.data;
      } else if (value == "Π") {
        this.listSemester = [];
        this.semesterId = null;
        this.examId = null;
        this.listExam = [];
        this.listClass = [];
        this.classId = null;
        this.listCourse = [];
        this.courseId = null;
        let result = await this.fetchDataDynamic(2253, this.academicYearId);
        this.listThesis = result.data;
      } else if (value == "Α") {
        this.listSemester = [];
        this.semesterId = null;
        this.listClass = [];
        this.classId = null;
        this.listCourse = [];
        this.courseId = null;
        this.examId = null;
        this.listExam = [];
        this.thesisId = null;
        this.listThesis = [];
        this.setTeacherList();
      } else if (value == "Ε") {
        this.listSemester = [];
        this.semesterId = null;
        this.listClass = [];
        this.classId = null;
        this.listCourse = [];
        this.courseId = null;
        this.thesisId = null;
        this.listThesis = [];
        let result = await this.fetchDataDynamic(2250, this.academicYearId);
        this.listExam = result.data;
      }
    },

    async onSetSemester(value) {
      this.listClass = [];
      this.listCourse = [];
      // fetch class
      let result = await this.fetchDataDynamic(2004, value);
      this.listClass = result.data;

      // fetch Courses
      let lessons = await this.fetchDataDynamic(2008, value);
      this.listCourse = lessons.data;
    },

    async onSetExam(value) {
      this.listClassCourse = [];
      let result = await this.fetchDataDynamic(2251, value);
      this.listClassCourse = result.data;
    },

    async setTeacherList() {
      if (this.tpy == "Δ" && this.courseId != null && this.classId != null) {
        let result = await this.fetchDataDynamic(
          2229,
          this.classId + "." + this.courseId
        );
        this.teacherList = result.data;
      } else if (this.tpy == "Π" && this.thesisId != null) {
        let result = await this.fetchDataDynamic(2254, this.thesisId);
        this.teacherList = result.data;
      } else if (this.tpy == "Α") {
        let result = await this.fetchDataDynamic(2351, this.schoolId);
        this.teacherList = result.data;
      } else if (this.tpy == "Ε" && this.classCourseId != null) {
        let result = await this.fetchDataDynamic(2252, this.classCourseId);
        this.teacherList = result.data;
      }
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date, dateName) {
      if (!date || !isFormattedDate(date)) {
        if (dateName == "entryDate") {
          this.entryDate = null;
          this.entryDateFormatted = null;
        }
        return null;
      }

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    async onSubmit() {
      try {
        this.$v.$touch();

        if (this.$v.$invalid) return;
        this.loader = true;

        let content = {
          entryDate: this.entryDate,
          tpy: this.tpy,
          trainnerId: this.trainnerId,
          numOfHours: this.numOfHours,
          yearId: this.academicYearId,
        };
        if (this.tpy == "Δ") {
          content.classId = this.classId;
          content.lessonId = this.courseId;
        } else if (this.tpy == "Π") {
          content.degreeId = this.thesisId;
        } else if (this.tpy == "Ε") {
          content.classExamId = this.classCourseId;
        }

        await this.addTeacherHour(content);

        this.loader = false;
        await this.$emit("handler");
        this.$emit("close");
      } catch (e) {
        this.loader = false;
      }
    },

    getDataStaticList(code) {
      return this.staticList.filter((element) => {
        if (element.lov_grp_id == code) {
          return element;
        }
      });
    },

    async fetchDataDynamic(groupId, parentId) {
      let body = {
        type: this.appId,
        parentCd: parentId,
        roleId: this.selectedRole,
      };
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_BASE_URL}/value/call/${groupId}`,
          body
        );
        return res;
      } catch (e) {
        return [];
        // throw e;
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>